import { defineMessages } from "react-intl";

export const messages = defineMessages({
  numberOfDays: {
    id: "settings.anonymize.inputText.numberOfDays.label",
    defaultMessage: "Number of days",
    description: "Label for input for number of days",
  },
});
